export const coreYellow = '#FCD823';
export const coreRed = '#DB3B22';
export const coreWaterBlue = '#91ABA7';
export const coreBlue = '#293745';
export const coreDarkBlue = '#1E2731';
export const coreWhite = '#FFFFFF';
export const coreNavy = '#1B3058';
export const coreLightGrey = '#FAFAFA';
